export default {
    userInfo:(state)=>state.user,
    userPermissions: (state) => state.userPermissions,
    userRoles: (state) => state.roles,
    supervisorNotification: (state) => state.notifications,
}
